import React from 'react';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { Box, Text, Flex } from 'atoms';
import { ColorRound, Rupee } from 'components';

const Container = styled(Box)`
	width: 85%;
	padding: 10px 10px 5px;
	border-radius: 5px;
	background: #fff;
`;

function getStatus(data) {
	const { status = 'Pending' } = data;

	if (status === 'No Bill Back') {
		return 'Invoice Settled';
	}
	if (status === 'Bill Back') {
		return 'Invoice Returned';
	}

	return status;
}

export default function FilledDetails({ data }) {
	if (isEmpty(data)) return <div></div>;

	const { status = 'Pending', payment = [] } = data;

	if (status === 'Pending') {
		return null;
	}

	return (
		<Container border="1px solid" borderColor={status === 'Bill Back' ? '#FFB056' : '#50AC08'}>
			<Flex justifyContent="space-between">
				<Flex flexWrap="wrap" width="67%">
					{payment?.map((item) => (
						<Box key={item?.id} minWidth="80px" mb="10px">
							{item?.payment_type && item?.amount && (
								<Text fontSize="12px" fontWeight="600" pt="5px" pr="10px">
									{item?.payment_type}: <Rupee>{item?.amount}</Rupee>
								</Text>
							)}
						</Box>
					))}
				</Flex>
				{data?.status !== 'Pending' && (
					<Flex alignItems="center" justifyContent="flex-end" width="33%">
						<ColorRound color={status === 'Bill Back' ? 'orange' : 'green'} />
						<Text
							fontSize="12px"
							mb="5px"
							color={status === 'Bill Back' ? '#FFB056' : '#50AC08'}
						>
							{getStatus(data)}
						</Text>
					</Flex>
				)}
			</Flex>
		</Container>
	);
}

FilledDetails.propTypes = {
	data: PropTypes.shape({
		status: PropTypes.string,
		payment: PropTypes.array,
		billtype: PropTypes.string,
	}),
};
